import Seo from "@/components/Seo";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { SITE } from "@/content/copy";

const SECTIONS = [
  {
    h: "Who we are",
    p: "Clarus Partners (ABN 49 308 724 557) provides remote bookkeeping, Xero clean-up and fractional CFO services to Australian small businesses. This policy explains how we handle personal information in line with the Australian Privacy Principles under the Privacy Act 1988 (Cth).",
  },
  {
    h: "What we collect",
    p: "When you download a checklist, request a quote or book a consultation, we collect your name, email address, business name, industry, the state of your bookkeeping, and anything you choose to tell us in the message field. When you book through Calendly, their privacy policy also applies to the details you give them.",
  },
  {
    h: "Why we collect it",
    p: "We use your details to respond to your enquiry, send you the resource you asked for, provide our services, and - only where you've asked to hear from us - send occasional follow-ups about your enquiry. We don't sell or rent your information to anyone.",
  },
  {
    h: "How we store it",
    p: "Your information is stored in systems protected by encryption in transit and at rest, with access limited to Nima Riazati. Client financial data is handled inside Xero, which uses bank-grade security, under least-privilege access.",
  },
  {
    h: "Analytics and advertising cookies",
    p: "With your continued use of the site, we use Google Analytics and (when active) Google Ads and Meta advertising tags to understand how the site is used and to measure our advertising. You can block these in your browser settings without affecting your ability to use the site.",
  },
  {
    h: "Your rights",
    p: `You can ask to see, correct or delete the personal information we hold about you at any time by emailing ${SITE.email}. Every marketing email we send includes an unsubscribe option, in line with the Spam Act 2003.`,
  },
  {
    h: "Contact",
    p: `Questions about this policy: ${SITE.email}. Last updated: [NIMA TO PROVIDE - launch date].`,
  },
];

export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Privacy Policy | Clarus Partners"
        description="How Clarus Partners collects, uses and protects your personal information, in line with the Australian Privacy Principles."
      />
      <Header />
      <main className="py-20 lg:py-28">
        <div data-testid="privacy-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-navy">Privacy Policy</h1>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.h}>
                <h2 className="text-xl font-bold text-navy">{s.h}</h2>
                <p className="mt-3 text-base text-navy/70 leading-relaxed">{s.p}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
